import React from 'react';
import Button from '../../../components/ui/Button';


const DeleteConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  userName,
  isMultiple,
  count
}) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e?.target === e?.currentTarget) {
      onClose?.();
    }
  };

  const handleConfirm = () => {
    onConfirm?.();
    onClose?.();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50" onClick={handleBackdropClick}>
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div className="flex items-center space-x-3">
            <div className="flex-shrink-0 w-10 h-10 bg-red-100 rounded-full flex items-center justify-center">
              <svg className="w-5 h-5 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-foreground">
                {isMultiple ? 'Excluir usuários' : 'Excluir usuário'}
              </h3>
              <p className="text-sm text-muted-foreground">
                Esta ação não pode ser desfeita
              </p>
            </div>
          </div>
          
          <Button
            variant="ghost"
            size="sm"
            onClick={onClose}
            iconName="X"
            className="text-muted-foreground hover:text-foreground"
          />
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="mb-4">
            {isMultiple ? (
              <p className="text-foreground">
                Tem certeza que deseja excluir <span className="font-semibold text-red-600">{count} usuários selecionados</span>? 
                Isso removerá permanentemente as contas e todos os dados associados.
              </p>
            ) : (
              <p className="text-foreground">
                Tem certeza que deseja excluir o usuário <span className="font-semibold text-red-600">"{userName}"</span>? 
                Isso removerá permanentemente a conta e todos os dados associados.
              </p>
            )}
          </div>

          <div className="bg-red-50 border border-red-200 rounded-lg p-3 mb-4">
            <div className="flex items-start space-x-2">
              <svg className="w-4 h-4 text-red-600 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
              <div className="text-sm text-red-800">
                <p className="font-medium mb-1">Atenção: esta ação é permanente!</p>
                <ul className="list-disc list-inside space-y-1 text-xs">
                  <li>O acesso do usuário será imediatamente revogado</li>
                  <li>Todas as sessões serão encerradas</li>
                  <li>Os dados não poderão ser recuperados após a exclusão</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="flex items-center justify-end space-x-3 p-6 border-t border-border bg-muted/20">
          <Button
            variant="outline"
            onClick={onClose}
          >
            Cancelar
          </Button>
          <Button
            variant="destructive"
            onClick={handleConfirm}
            iconName="Trash2"
            iconPosition="left"
          >
            {isMultiple ? `Excluir ${count} usuários` : 'Excluir usuário'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;